export enum BalanceDetailsPostingMethod {
    FIFO = 'FIFO',
    WEIGHTED = 'WeightedSplit',
    EQUAL = 'EqualSplit'
}
